module.exports = __webpack_public_path__ + "static/img/newHuaiC4.0fd4d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/newHuaiC4.png
// module id = 5zr6
// module chunks = 0